/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable import/first */
// Entry point for the feed.web.js bundle, this is the first JS from our app that runs
import * as Sentry from '@sentry/react';
import {
    Dedupe as DedupeIntegration,
    ExtraErrorData as ExtraErrorDataIntegration,
} from '@sentry/integrations';

function getEnv(host = 'dev.evbqa.com') {
    if (host.indexOf('eventbrite') > -1) {
        return 'production';
    }

    if (host.indexOf('dev') > -1) {
        return 'dev';
    }

    if (host.indexOf('evbstage') > -1) {
        return 'stage';
    }

    if (host.indexOf('evbqa') > -1) {
        return 'qa';
    }

    return 'dev';
}

const shouldUseSentry = () => {
    const env = getEnv(window.location.host);

    return (
        env === 'production' || env === 'qa' || env === 'stage' || env === 'dev'
    );
};

const setSentryCustomTags = () => {
    if (window.__SERVER_DATA__.guest_id) {
        Sentry.setTag('guest_id', window.__SERVER_DATA__.guest_id);
    }

    Sentry.setTag('page_locale', window.__i18n__?.locale || '');
};

if (shouldUseSentry()) {
    Sentry.init({
        dsn:
            'https://3790e637446c42a3a7f30f5868ec3159@o375540.ingest.sentry.io/5902718',
        integrations: [
            new DedupeIntegration(),
            new ExtraErrorDataIntegration(),
        ],
        release: window.__SERVER_DATA__.app_version,
        environment: getEnv(window.location.host),
    });

    if (window.__SERVER_DATA__.user.email) {
        const sentryUser = {
            email: window.__SERVER_DATA__.user.email,
            id: window.__SERVER_DATA__.user.publicId,
        };

        // MUST have one of email, id, username, or ip to call setUser()
        Sentry.setUser(sentryUser);
    }

    setSentryCustomTags();
}

import React from 'react';
import { getLocaleOverride, setupAsync, getParentLocale } from '@eb/i18n';
import { loadableReady } from '@loadable/component';
import { hydrate } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

if (parentLocale !== 'en_US') {
    setupAsync({
        parentLocale,
        translations: /* webpackChunkName: "i18n-translation" */ import(
            `./i18n/translations/${parentLocale}.json`
        ),
    });
}

// render app with server props to the DOM
loadableReady(() => {
    hydrate(<App {...props} />, document.getElementById('root'));
});

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
